<template>

  <div class="item_main">

    <div class="title">1.进入听写</div>
    <div class="content">点击弹窗中的听写模式，进入听写页面。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/entedictation.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>


    <div class="title">2.开启</div>
    <div class="content">点击底部中间播放按钮，即可开启听写模式。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/dictation.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">3.设置</div>
    <div class="content">点击随身听页面右下角的设置按钮，弹出设置弹窗，可设置定时、重复次数、间隔时间、字母拼读、循环播放等参数。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/dictationsetup.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">4.筛选</div>
    <div class="content">点击随身听页面左下角的筛选按钮，可选择需要听写的单词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/dictationfilter.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">5.隐藏单词</div>
    <div class="content">点击随身听页面隐藏按钮，可隐藏听写的单词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/dictationhiddenword.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

   





    </div>
  

  
 



  
  

  
    
  </template>
  
  <script setup>

  </script>
  
  <style scoped>

  .item_main {
    font-size: 0.4rem;
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    text-align: left;
  }

  .title {
    font-size: 0.45rem;
    font-weight: bold;
    margin-top: 0.4rem;
    margin-bottom: 0.2rem;
  }
  .second_title {
    font-size: 0.42rem;
    
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .content {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  
  </style>